/**
 * Dynamically injects a CSS stylesheet link into the document head.
 * Used when this module is loaded as a remote via Module Federation.
 */
export function injectStylesheet(href: string): void {
  const id = "xplatform-releases-frontend-module-styles";
  if (document.getElementById(id)) return;

  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}
